import level from './assets/img/level.svg';
import border from './assets/img/border.svg';
import first from './assets/img/first.svg';
import second from './assets/img/second.svg';
import third from './assets/img/third.svg';
import Lottery from "./hardhat/artifacts/contracts/Lottery.sol/Lottery.json"
import Token from "./hardhat/artifacts/contracts/Lottery.sol/IERC20.json"
import { ethers } from 'ethers';
import Decimal from "decimal.js"

import { Progress, Button, Input, message } from 'antd';
import { IntlProvider, FormattedMessage } from 'react-intl';
import messages from './lang/index';
import { useState } from 'react';


let USDTAddr = "0x720416063b4cFE8300fFFACC478009657d85bb90";
let ATokenAddr = "0x2f38a08A893b122d0006Bd5865b77a4208f9Ea3e";
let BTokenAddr = "0xaA4cfc66fef889CAF3ddB770b0A3bbB4fABA6415";
let LotteryAddr = "0x3100eE981Cb8726FF46747281fA91e1350ABA5Bb";

let USDTContractdecimals;
let ATokenContractdecimals;
let BTokenContractdecimals;
let Rounds;

let Provider;
let USDTContract;
let ATokenContract;
let BTokenContract;
let LotteryContract;
let account;
let chainInfo;
let connWallet;
let Mainnet;

let inputreadOnly;

function App() {
  const [locale, setLocale] = useState(localStorage.getItem('locale') || 'zh');
  const [Account, setAccount] = useState();
  const [Round, setRound] = useState("--");
  const [NumberP, setNumberP] = useState("--");
  const [ProgressBar, setProgressBar] = useState(0);
  //const [thirdPrize, setThirdPrize] = useState(0);

  const [UsdtBalance, setUsdtBalance] = useState("--");
  const [GameRewards, setGameRewards] = useState("--");
  //const [RecommendRewards, setRecommendRewards] = useState("--");
  const [TokenBRewards, setTokenBRewards] = useState("--");
  //const [RecommendAddr, setRecommendAddr] = useState(locale === 'zh' ? '请输入推荐人' : 'Please enter the recommender');
  const [MyUsdtBalance, setMyUsdtBalance] = useState("--");
  const [MyTokenABalance, setMyTokenABalance] = useState("--");
  const [MyTokenBBalance, setMyTokenBBalance] = useState("--");
  const [TokenAName, setTokenAName] = useState("--");
  const [TokenBName, setTokenBName] = useState("--");

  const [ConnectWalletLoading, setConnectWalletLoading] = useState(false)
  const [LotteryLoading, setLotteryLoading] = useState(false)
  const [ReceiveRewardsUSDTLoading, setReceiveRewardsUSDTLoading] = useState(false)
  const [ReceiveRewardsBtokenLoading, setReceiveRewardsBtokenLoading] = useState(false)
  // const [RefRewardUSDTLoading, setRefRewardUSDTLoading] = useState(false)
  // const [Bind_RecommenderLoading, setBind_RecommenderLoading] = useState(false)

  const [Winner1, setWinner1] = useState("");
  const [Winner2, setWinner2] = useState("");
  //const [Winner3, setWinner3] = useState("");

  //const [InuptRefData, setInuptRefData] = useState()

  function isMetaMaskInstalled() {
    //Have to check the ethereum binding on the window object to see if it's installed
    const { ethereum } = window;
    return Boolean(ethereum && ethereum.isMetaMask);
  }

  let ConnectWallet = async () => {
    try {
      if (isMetaMaskInstalled()) {
        if (connWallet) {
          return
        }
        setConnectWalletLoading(true);
        await GetAccount();
        Provider = new ethers.providers.Web3Provider(window.ethereum);
        LotteryContract = new ethers.Contract(LotteryAddr, Lottery.abi, Provider.getSigner());
        USDTContract = new ethers.Contract(USDTAddr, Token.abi, Provider.getSigner());
        ATokenContract = new ethers.Contract(ATokenAddr, Token.abi, Provider.getSigner());
        BTokenContract = new ethers.Contract(BTokenAddr, Token.abi, Provider.getSigner());

        USDTContractdecimals = await USDTContract.decimals();
        ATokenContractdecimals = await ATokenContract.decimals();
        let ATokenContractsymbol = await ATokenContract.symbol();
        setTokenAName(ATokenContractsymbol);
        BTokenContractdecimals = await BTokenContract.decimals();
        let BTokenContractsymbol = await BTokenContract.symbol();
        setTokenBName(BTokenContractsymbol);
        await chainChanged();
        await GetGameInfo();
        setConnectWalletLoading(false);
        Provider.on('block', async (blockNumber) => {
          //console.log("blockNumber:", blockNumber)
          await GetGameInfo();
        });
        window.ethereum.on('chainChanged', async function () {
          if (connWallet) {
            connWallet = false;
            await ConnectWallet()
            await GetAccount();
          }

        })
        window.ethereum.on('accountsChanged', async function () {
          //if (connWallet) {
          connWallet = false;
          await ConnectWallet()
          await GetAccount();
          //}
        })
      }

    } catch (err) {
      setConnectWalletLoading(false);
      console.log(err)
    }

  }

  let GetAccount = async () => {
    try {
      await window.ethereum.request({ method: 'eth_requestAccounts' })
        .then((accounts) => {
          account = accounts[0];
        }).catch((error) => {
          console.error(error)
        });
    } catch (err) {
      console.log(err)
    }

  }

  let chainChanged = async () => {
    try {
      Provider = new ethers.providers.Web3Provider(window.ethereum);
      chainInfo = await Provider.getNetwork();
      if (Mainnet) {
        if (chainInfo.chainId !== 131419) {
          setAccount("Please switch to the ETND main network");
          await window.ethereum.request({
            method: 'wallet_switchEthereumChain',
            params: [{ chainId: '0x2015b' }],
          });
        } else {
          setAccount(account.substring(0, 10) + '...' + account.substring(33, 42).toString());
        }
      } else {
        //if (chainInfo.chainId !== 31337) {
        if (chainInfo.chainId !== 131419) {
          setAccount("Please switch to the ETND network");
          await window.ethereum.request({
            method: 'wallet_switchEthereumChain',
            params: [{ chainId: '0x2015b' }],
          });
        } else {
          setAccount(account.substring(0, 10) + '...' + account.substring(33, 42).toString());
        }
      }
    } catch (err) {
      Provider = new ethers.providers.Web3Provider(window.ethereum);
      chainInfo = await Provider.getNetwork();

      if (Mainnet) {
        if (chainInfo.chainId !== 131419) {
          setAccount("Please switch to the ETND main network");
          await window.ethereum.request({
            method: 'wallet_switchEthereumChain',
            params: [{ chainId: '0x2015b' }],
          });
        } else {
          setAccount(account.substring(0, 10) + '...' + account.substring(33, 42).toString());
        }
      } else {
        //if (chainInfo.chainId !== 31337) {
        if (chainInfo.chainId !== 131419) {
          setAccount("Please switch to the ETND network");
          await window.ethereum.request({
            method: 'wallet_switchEthereumChain',
            params: [{ chainId: '0x2015b' }],
          });
        } else {
          setAccount(account.substring(0, 10) + '...' + account.substring(33, 42).toString());
        }
      }
      console.log(err)
    }
    connWallet = true;
  }

  let ConnectWalletButton = () => {
    try {
      if (Account) {
        return Account;
      } else {
        return (<FormattedMessage id="link" />);
      }
    } catch (err) {
      console.log(err)
    }
  }

  let GetGameInfo = async () => {
    try {
      await GameRound();
      await GetNumberP();
      await GetAllBalance();
      await Getreceive();
      //await GetRecommendAddr();
      await GetWinnerInfo();
      await GetWinner2Info();
      //await GetWinner3Show();
    } catch (err) {
      console.log(err)
    }
  }

  let GameRound = async () => {
    try {
      let round = await LotteryContract.round();
      setRound(round.toString())
      Rounds = round.toString();
      //console.log("round",round.toString())
    } catch (err) {
      console.log(err)
    }
  }

  let GetNumberP = async () => {
    try {
      let numberP = await LotteryContract.getPCount();
      setNumberP(numberP.toString())
      setProgressBar(new Decimal(numberP.toString()).div(new Decimal(0.8)).toFixed(2))
      //console.log("numberP",numberP.toString())
    } catch (err) {
      console.log(err)
    }
  }

  let GetAllBalance = async () => {
    try {
      let _MyUsdtBalance = await USDTContract.balanceOf(account);
      setMyUsdtBalance((new Decimal(_MyUsdtBalance.toString()).div(new Decimal(10).pow(USDTContractdecimals.toString()))).toFixed(6));
      let _MyTokenABalance = await ATokenContract.balanceOf(account);
      setMyTokenABalance((new Decimal(_MyTokenABalance.toString()).div(new Decimal(10).pow(ATokenContractdecimals.toString()))).toFixed(6));
      let _MyTokenBBalance = await BTokenContract.balanceOf(account);
      setMyTokenBBalance((new Decimal(_MyTokenBBalance.toString()).div(new Decimal(10).pow(BTokenContractdecimals.toString()))).toFixed(6));
      let _ContractUsdtBalance = await USDTContract.balanceOf(LotteryAddr);
      setUsdtBalance((new Decimal(_ContractUsdtBalance.toString()).div(new Decimal(10).pow(USDTContractdecimals.toString()))).toFixed(1));
    } catch (err) {
      console.log(err)
    }
  }

  let Getreceive = async () => {
    try {
      let _GameRewards = await LotteryContract.UsdtValue(account);
      //let _RecommendRewards = await LotteryContract.RefReward(account);
      let _TokenBRewards = await LotteryContract.TokenB(account);
      setGameRewards((new Decimal(_GameRewards.toString()).div(new Decimal(10).pow(USDTContractdecimals.toString()))).toFixed(6));
      //setRecommendRewards((new Decimal(_RecommendRewards.toString()).div(new Decimal(10).pow(USDTContractdecimals.toString()))).toFixed(6))
      setTokenBRewards((new Decimal(_TokenBRewards.toString()).div(new Decimal(10).pow(BTokenContractdecimals.toString()))).toFixed(6))
    } catch (err) {
      console.log(err)
    }
  }

  // let GetRecommendAddr = async() =>{
  //   try {
  //     let _RefAddr = await LotteryContract.Ref(account);
  //     if (_RefAddr.toString() != "0x0000000000000000000000000000000000000000"){
  //       setRecommendAddr(_RefAddr.toString());
  //       inputreadOnly = true;
  //     }
  //   }catch (err) {
  //     console.log(err)
  //   }
  // }

  let GetWinnerInfo = async () => {
    if (new Decimal(Rounds) <= 1) {
      setWinner1("0x0000000000000000000000000000000000000000");
      return
    } else {
      let _BigWinnerinfo = await LotteryContract.BigWinnerinfo(Rounds - 1);
      setWinner1(_BigWinnerinfo);
    }

  }

  let GetWinner2Info = async () => {
    if (new Decimal(Rounds) <= 1) {
      let Winner2s = ["0x0000000000000000000000000000000000000000"];
      for (let i = 1; i < 30; i++) {
        Winner2s.push("0x0000000000000000000000000000000000000000");
      }
      setWinner2(Winner2s);
      return
    } else {
      let _BigWinner2info = await LotteryContract.BigWinner2info(Rounds - 1);
      setWinner2(_BigWinner2info);
    }
  }

  // let GetWinner3Show = async()=>{
  //   if (new Decimal(Rounds.toString()).lessThanOrEqualTo(new Decimal(1))){
  //     let _BigWinner50info = ["0x0000000000000000000000000000000000000000"]
  //     for(let i = 0;i<49;i++){
  //       _BigWinner50info.push("0x0000000000000000000000000000000000000000")
  //     }

  //     let _BigWinner50info_ = _BigWinner50info.map((v)=>{
  //        return <div>{v}</div>
  //      })
  //     // console.log(_BigWinner50info_)
  //     setWinner3(_BigWinner50info_)
  //     setThirdPrize(_BigWinner50info_.length)

  //   }else{
  //     let _BigWinner50info = await LotteryContract.BigWinner50info(Rounds - 1);
  //     //console.log(JSON.stringify(_BigWinner50info))

  //     let _BigWinner50info_ = _BigWinner50info.map((v)=>{
  //       return v.toString()
  //     })
  //     // for(let j=0;j<30;j++){
  //     //   _BigWinner50info_.push(ethers.utils.keccak256(ethers.utils.toUtf8Bytes((Rounds - 1).toString() + j.toString())).toString())
  //     // }

  //     //console.log()
  //     // let _BigWinner50info_ = _BigWinner50info.map((v)=>{
  //     //   console.log("vvv",v)
  //     //   return <div>{v}</div>
  //     // })
  //     //ethers.utils.keccak256(ethers.utils.toUtf8Bytes((Rounds - 1).toString() + i.toString())).toString()
  //     //console.log("_BigWinner50info_",_BigWinner50info_)

  //     setWinner3(_BigWinner50info_)
  //     setThirdPrize(_BigWinner50info_.length)
  //   }
  // }

  let PlayButton = async () => {
    try {
      if (!connWallet) {
        if (locale === 'zh') {
          message.warning("请先连接钱包", 0.7);
          return
        }
        message.warning("Please connect your wallet first", 0.7);
        return
      }
      // let refaddr = await LotteryContract.Ref(account)
      // if (refaddr == "0x0000000000000000000000000000000000000000") {
      //   if (locale === 'zh'){
      //     message.warning("请先绑定推荐人", 0.7);
      //     return
      //   }
      //   message.warning("Please bind the recommender first", 0.7);
      //   return
      // }
      setLotteryLoading(true);
      let _value = await ATokenContract.allowance(account, LotteryAddr);
      let _amount = await ATokenContract.balanceOf(account);
      let _buyValue = await LotteryContract.buyValue();
      let _buyValue_ = ethers.utils.parseUnits(_buyValue.toString(), ATokenContractdecimals.toString())

      let eq = new Decimal(_amount.toString()).lessThan(new Decimal(_buyValue_.toString()))
      if (eq) {
        //console.log("locale",locale)
        if (locale === 'zh') {
          message.warning("请检查代币余额", 0.7);
          setLotteryLoading(false);
          return
        }
        message.warning("Please check the token balance", 0.7);
        setLotteryLoading(false);
        return
      }

      if (_value == 0 || new Decimal(_value.toString()).lessThan(new Decimal(_buyValue_.toString()))) {
        let _tx = await ATokenContract.approve(LotteryAddr, _buyValue_);
        await _tx.wait()
      }

      let tx = await LotteryContract.play();
      await tx.wait()
      setLotteryLoading(false);
    } catch (err) {
      setLotteryLoading(false);
      console.log(err)
    }
  }

  let ReceiveRewardsUSDTButton = async () => {
    try {
      if (!connWallet) {
        if (locale === 'zh') {
          message.warning("请先连接钱包", 0.7);
          return
        }
        message.warning("Please connect your wallet first", 0.7);
        return
      }
      setReceiveRewardsUSDTLoading(true);
      let _tx = await LotteryContract.ReceiveRewardsUSDT();
      await _tx.wait()
      setReceiveRewardsUSDTLoading(false);
    } catch (err) {
      setReceiveRewardsUSDTLoading(false);
      console.log(err)
    }
  }

  let ReceiveRewardsBtokenButton = async () => {
    try {
      if (!connWallet) {
        if (locale === 'zh') {
          message.warning("请先连接钱包", 0.7);
          return
        }
        message.warning("Please connect your wallet first", 0.7);
        return
      }
      setReceiveRewardsBtokenLoading(true);
      let _tx = await LotteryContract.ReceiveRewardsBtoken();
      await _tx.wait()
      setReceiveRewardsBtokenLoading(false);
    } catch (err) {
      setReceiveRewardsBtokenLoading(false);
      console.log(err)
    }
  }

  // let RefRewardUSDTButton = async() =>{
  //   try {
  //     if (!connWallet) {
  //       if (locale === 'zh'){
  //         message.warning("请先连接钱包", 0.7);
  //         return
  //       }
  //       message.warning("Please connect your wallet first", 0.7);
  //       return
  //     }
  //     setRefRewardUSDTLoading(true);
  //     let _tx = await LotteryContract.RefRewardUSDT();
  //     await _tx.wait()
  //     setRefRewardUSDTLoading(false);
  //   }catch (err) {
  //     setRefRewardUSDTLoading(false);
  //     console.log(err)
  //   }
  // }

  // let Bind_RecommenderButton = async(_ref) =>{
  //   try {
  //     if (!connWallet) {
  //       if (locale === 'zh'){
  //         message.warning("请先连接钱包", 0.7);
  //         return
  //       }
  //       message.warning("Please connect your wallet first", 0.7);
  //       return
  //     }
  //     if(inputreadOnly){
  //       return
  //     }
  //     let _ref1 = _ref.toString().replace(/\s*/g,"");
  //     //console.log(_ref1)
  //     setBind_RecommenderLoading(true);
  //     let _tx = await LotteryContract.Bind_Ref(_ref1);
  //     await _tx.wait();
  //     await GetRecommendAddr();
  //     setBind_RecommenderLoading(false);
  //   }catch (err) {
  //     setBind_RecommenderLoading(false);
  //     console.log(err)
  //   }
  // }

  // 切换语言
  const onToggleLocale = () => {
    let _locale = locale === 'zh' ? 'en' : 'zh';
    localStorage.setItem('locale', _locale);
    setLocale(_locale);
  }

  // 密文显示
  const showCiphertext = (value) => {
    return value
    if (!value) return '';
    const text = `${value}`;
    return `${text.substring(0, 10)}******${text.substring(text.length - 8)}`;
  }

  const showCiphertext3 = (value) => {
    return value
    if (!value) return '';
    // console.log(value,"-----------------------")
    // console.log(`${value.substring(0, 10)}******${value.substring(value.length - 8)}`)
    return `${value.substring(0, 10)}******${value.substring(value.length - 8)}`;
  }

  return (
    <IntlProvider key={locale} locale={locale} messages={messages[locale]}>
      <div className="max-width-500 w-100 h-100 px-3 text-md color-white overflow-auto slim-no-scroll pt-3 pb-5">
        <header className="d-flex align-items-center justify-content-between mb-3 color-purple-5">
          <Button className="ant-btn-purple" onClick={ConnectWallet} loading={ConnectWalletLoading}>
            <ConnectWalletButton />
          </Button>
          <div onClick={onToggleLocale} className="flex-center-center">
            <svg t="1660977407777" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3411" width="1.4rem" height="1.4rem"><path d="M512.9 960.2c-245.5 0-445.3-199.8-445.3-445.3S267.4 69.6 512.9 69.6c97.2 0 189.6 30.8 267.1 89 15.1 11.4 18.2 32.8 6.8 48-11.4 15.1-32.8 18.2-48 6.8-65.6-49.2-143.7-75.2-226-75.2C305 138.2 136 307.2 136 515s169 376.8 376.8 376.8 376.8-169 376.8-376.8c0-48.5-9.1-95.8-27-140.4-7.1-17.6 1.5-37.5 19-44.6 17.6-7.1 37.5 1.5 44.6 19 21.2 52.8 32 108.6 32 165.9 0 245.6-199.7 445.3-445.3 445.3z" fill="#d5c7fc" p-id="3412"></path><path d="M829.1 273.3m-39.5 0a39.5 39.5 0 1 0 79 0 39.5 39.5 0 1 0-79 0Z" fill="#d5c7fc" p-id="3413"></path><path d="M523.6 954.4c-6.3 0-12.6-2.2-17.8-6.6-16.1-13.7-31.6-28.6-46.1-44.3-45.5-48.9-81.4-104.9-106.8-166.5-27.4-66.3-41.4-136.5-41.9-208.8v-3.5c0-61.6 10.1-122.2 29.8-180 28.8-84.1 78.2-161.2 143-222.8 4.9-4.7 10-9.3 15.1-13.8 11.3-10 28.7-9 38.7 2.4 10 11.3 9 28.7-2.4 38.7-4.6 4.1-9.2 8.3-13.6 12.5-58.3 55.6-102.9 125-128.9 200.8-17.8 52.1-26.9 106.7-26.9 162.3v3.3c0.4 65 13.1 128.3 37.7 188 22.9 55.5 55.3 106 96.3 150.1 13.1 14.2 27.1 27.6 41.5 39.9 11.5 9.8 12.9 27.1 3 38.6-5.2 6.4-12.9 9.7-20.7 9.7z" fill="#d5c7fc" p-id="3414"></path><path d="M487.4 953.1c-8.4 0-16.6-3.8-22-11-9.1-12.1-6.6-29.3 5.6-38.4 16-11.9 31.4-25 45.9-38.7 43.8-41.7 79.3-90.2 105.5-144.3 29.6-60.8 46.3-126.1 49.6-193.9 0.4-8.5 0.6-16.9 0.6-25 0-43.4-5.5-86.6-16.5-128.1-20.8-79.2-61.5-153-117.5-213.3-4-4.4-8.3-8.8-13.2-13.7-10.7-10.7-10.8-28-0.1-38.8 10.7-10.7 28-10.8 38.8-0.1 5.6 5.5 10.4 10.6 14.9 15.5 62 66.7 107.1 148.5 130.2 236.5 12.1 46.1 18.3 93.9 18.3 142.1 0 9-0.2 18.3-0.7 27.6-3.7 75.3-22.2 147.7-55.1 215.2-29.1 60-68.5 113.8-117 160-16 15.3-33.1 29.7-50.9 42.9-5 3.7-10.7 5.5-16.4 5.5z" fill="#d5c7fc" p-id="3415"></path><path d="M834.9 747.1c-5.3 0-10.7-1.5-15.4-4.8-58.1-39.7-122.1-67.9-190.2-83.9-42.6-10-86.6-15.1-130.8-15.1h-0.2c-33.2 0-66.3 2.8-98.6 8.5-73 12.7-142 39.3-204.9 78.9-12.8 8.1-29.7 4.2-37.8-8.6-8.1-12.8-4.2-29.7 8.6-37.8 69-43.4 144.6-72.5 224.7-86.5 35.4-6.2 71.7-9.3 108-9.3h0.2c48.4 0 96.6 5.6 143.3 16.6 74.7 17.5 144.9 48.5 208.6 92 12.5 8.5 15.7 25.6 7.2 38.1-5.4 7.7-14 11.9-22.7 11.9zM924 480.5l-801.8-0.3c-15.1 0-27.4-12.3-27.4-27.4 0-15.1 12.3-27.4 27.4-27.4l801.8 0.3c15.1 0 27.4 12.3 27.4 27.4 0 15.2-12.3 27.4-27.4 27.4z" fill="#d5c7fc" p-id="3416"></path></svg>
            <div className="ml-1">{locale.toUpperCase()}</div>
          </div>
        </header>
        <section className="flex-center-center pl-2">
          <div className="position-relative">
            <img src={level} alt="level" />
            <div className="level-text text-title text-bold">{Round}</div>
          </div>
        </section>
        <section className="mt-5">
          <div className="flex-center-center">
            <div>
              <FormattedMessage id="participants" />
            </div>
            <div className="color-light ml-2 text-plus">{NumberP}</div>
          </div>
          <div className="flex-center-center mt-2">
            <Progress className="warning" percent={ProgressBar} />
          </div>
          <div className="flex-center-center mt-4-5">
            <Button className="ant-btn-warning w-60" loading={LotteryLoading} onClick={PlayButton} >
              <FormattedMessage id="lottery" />
            </Button>
          </div>
        </section>

        <section className="flex-item text-sm mt-5 bg-dark-5 round-md">
          <div className="flex-content flex-vertical align-items-center justify-content-center px-3 py-2">
            <div className="flex-item align-items-center">
            </div>
            <div className="flex-item align-items-center mt-2">
              <div>
                USDT<FormattedMessage id="balance" />:
              </div>
              <div className="color-light ml-2 text-md">{MyUsdtBalance}</div>
            </div>
            <div className="flex-item align-items-center mt-2">
              <div>
                {TokenAName}<FormattedMessage id="balance" />:
              </div>
              <div className="color-light ml-2 text-md">{MyTokenABalance}</div>
            </div>
            <div className="flex-item align-items-center mt-2">
              <div>
                {TokenBName}<FormattedMessage id="balance" />:
              </div>
              <div className="color-light ml-2 text-md">{MyTokenBBalance}</div>
            </div>
          </div>
        </section>

        <section className="flex-item text-sm mt-5 bg-dark-5 round-md">
          <div className="flex-label text-center bg-purple round-md py-2 px-3 flex-vertical justify-content-center">
            <div>
              <FormattedMessage id="contract" />
            </div>
            <div>
              <FormattedMessage id="total" />
            </div>
            <div className="text-title color-light mt-1">{UsdtBalance}</div>
          </div>
          <div className="flex-content flex-vertical align-items-center justify-content-center px-3 py-2">

            <div className="flex-item align-items-center">
              <div>
                <FormattedMessage id="gameAward" />
              </div>
              <div className="color-light ml-2 text-md">{GameRewards}</div>
            </div>
            <Button className="ant-btn-warning w-60" loading={ReceiveRewardsUSDTLoading} onClick={ReceiveRewardsUSDTButton}>
              <FormattedMessage id="receive" />
            </Button>

            {/* <div className="flex-item align-items-center mt-2">
              <div>
                <FormattedMessage id="recommentAward" />
              </div>
              <div className="color-light ml-2 text-md">{RecommendRewards}</div>
            </div>
            <Button className="ant-btn-warning w-60" loading={RefRewardUSDTLoading} onClick={RefRewardUSDTButton}>
              <FormattedMessage id="receive" />
            </Button> */}

            <div className="flex-item align-items-center mt-2">
              <div>
                <FormattedMessage id="available" />
                {TokenBName}
                <FormattedMessage id="rewards" />
              </div>
              <div className="color-light ml-2 text-md">{TokenBRewards}</div>
            </div>
            <Button className="ant-btn-warning w-60" loading={ReceiveRewardsBtokenLoading} onClick={ReceiveRewardsBtokenButton}>
              <FormattedMessage id="receive" />
            </Button>

          </div>
        </section>
        {/* <section className="mt-5 flex-item input-box position-relative">
          <Input className="flex-content" placeholder={RecommendAddr} readOnly= {inputreadOnly} onChange={(event) => {
                  setInuptRefData(event.target.value)
                }} />
          <Button className="flex-label ant-btn-warning" loading={Bind_RecommenderLoading} onClick={async ()=>{
              await Bind_RecommenderButton(InuptRefData)
          }}>
            <FormattedMessage id="bind" />
          </Button>
        </section> */}



        {/*         <section className="mt-6">
          <div className="d-flex align-items-center justify-content-between mb-3">
            <img src={border} alt="" />
            <div className="text-center">
              <FormattedMessage id="introduction" />
            </div>
            <img src={border} className="right" alt="" />
          </div>
          <div className="round-md bg-dark-5 p-3 text-sm">
            <FormattedMessage id="detail" />
          </div>
        </section> */}
        <section className="mt-6" overflow-y="auto">
          <div className="d-flex align-items-center justify-content-between mb-3">
            <img src={border} alt="" />
            <div className="text-center">
              <FormattedMessage id="list" />
            </div>
            <img src={border} className="right" alt="" />
          </div>
          <div className="round-md bg-dark-5 p-3 text-sm text-center">
            <div className="mb-4">
              <div className="flex-center-center mb-3">
                <img width="20rem" src={first} alt="" />
                <div className="ml-2 color-light">
                  <FormattedMessage id="first" />
                </div>
              </div>
              <div className="color-purple-5">
                <div className="win-item">{showCiphertext(Winner1)}</div>
              </div>
            </div>
            <div className="mb-4">
              <div className="flex-center-center mb-3">
                <img width="20rem" src={second} alt="" />
                <div className="ml-2 color-white">
                  <FormattedMessage id="second" />
                </div>
              </div>
              <div className="color-purple-5">
                <div className="third-wrapper overflow-hidden">
                  {
                    new Array(2).fill(2).map((arrayItem, arrayIndex) => {
                      return (
                        <div className="third-box" key={arrayIndex} style={{ animationDuration: `${30 * 0.5}s` }}>
                          {
                            Winner2 && Winner2.map((item, index) => {
                              return <div className="win-item" key={index}>{showCiphertext(item)}</div>
                            })
                          }
                        </div>
                      )
                    })
                  }
                </div>
                {/* <div className="win-item">{showCiphertext(Winner2[0])}</div>
                <div className="win-item">{showCiphertext(Winner2[1])}</div> */}
              </div>
            </div>
            {/* <div>
              <div className="flex-center-center mb-3">
                <img width="20rem" src={third} alt="" />
                <div className="ml-2 color-warning-3">
                  <FormattedMessage id="third" />
                </div>
              </div>
              <div className="color-purple-5" >
                <div className="third-wrapper overflow-hidden">
                  {
                    new Array(2).fill(2).map((arrayItem, arrayIndex) => {
                      return (
                        <div className="third-box" key={arrayIndex} style={ { animationDuration: `${thirdPrize * 0.5}s` } }>
                          {
                            Winner3 && Winner3.map((item, index) => {
                              return <div className="win-item" key={index}>{showCiphertext3(item)}</div>
                            })
                          }
                        </div>
                      )
                    })
                  }
                </div>
              </div>
            </div> */}

          </div>
        </section>
      </div>
    </IntlProvider>
  );
}

export default App;
